"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RefreshIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M18.54 5.817v-1.55a1.243 1.243 0 012.485 0v5.784h-5.782a1.243 1.243 0 110-2.486h1.51A6.502 6.502 0 005.59 10.914h-.002a1.25 1.25 0 11-2.468-.394C3.827 6.254 7.533 3 12 3c2.576 0 4.9 1.082 6.54 2.817zM5.51 18.236v1.547a1.243 1.243 0 01-2.485 0V14h5.783a1.243 1.243 0 010 2.485H7.295a6.501 6.501 0 0011.144-3.59l.012.001a1.25 1.25 0 012.449.388l.009.001a8.985 8.985 0 01-.03.195C20.173 17.746 16.467 21 12 21a8.974 8.974 0 01-6.49-2.764z"
  }));
});
RefreshIcon.category = 'Content';
var _default = RefreshIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/RefreshIcon.js
// module id = 1135
// module chunks = 0